export const API_ENDPOINTS = Object.freeze({
  bonobo: process.env.REACT_APP_BONOBO_API_URL,
  ekardo: process.env.REACT_APP_EKARDO_API_URL,
  gelada: process.env.REACT_APP_GELADA_API_URL,
  howler: process.env.REACT_APP_HOWLER_API_URL,
  google: process.env.REACT_APP_GOOLE_MAP_API_KEY,
});
